import React from "react";
import { connect } from "react-redux";
import { atletePhotosFunc } from "../../../../../../../data-store/actions/atlete-actions";
import { eventPhotoConfiguration } from "../../../../../../../data-store/actions/events-actions";

import AtleteControls from "./AtleteControls";
import AtleteCharts from "./AtleteCharts";
import AtletePhotos from "./AtletePhotos";

class AtleteReportsContainerView extends React.Component {
  //({eventDetail, resultado, atletePhotos, eventConfiguration})
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  //                        <AtleteCharts resultado={this.props.resultado}/>

  render() {
    return (
      <div className="row">
        <div className="col s12">
          <hr />
          <AtleteControls
            resultado={this.props.resultado}
            puntosControl={
              this.props.puntosControl && this.props.puntosControl.val()
            }
          />
          <hr />
          <AtleteCharts resultado={this.props.resultado} />
          <hr />
          <AtletePhotos
            resultado={this.props.resultado}
            atletePhotos={this.props.atletePhotos}
          />
          <hr />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (
  dispatch,
  { resultado, eventDetail, eventConfiguration }
) => {
  var puntoFotografico = 1;
  var eventoIndex = `evento_${eventDetail.iDEvento}`;
  var fechaHoraMeta = resultado.fhm;
  return {
    atletePhotos: dispatch(
      atletePhotosFunc(eventoIndex, fechaHoraMeta, puntoFotografico)
    ),
    eventPhotoConfiguration: dispatch(eventPhotoConfiguration(eventoIndex)),
  };
};

const mapStateToProps = (state) => {
  console.log(state);

  const eventConfiguration = {
    cronometrajeDisponible: true,
    eventoPublico: true,
    fotografiasDisponibles: true,
    inscripcionesDisponibles: false,
    resultadosDisponibles: true,
    tiempoRealDisponible: true,
  };

  // TODO: cambiar state.events.eventConfiguration  colocar esto y borrar la variable
  // regresar la vista de graficas a su lugar, la tenfo arriba comentada.

  return {
    atletePhotos: state.atlete.atletePhotos,
    eventDetail: state.events.eventDetail,
    eventConfiguration: state.events.eventConfiguration,
    // Crudo (no .val()) a propósito: mapStateToProps corre en cada
    // dispatch de Redux para decidir si hay que re-renderizar — si acá se
    // llamara .val(), devolvería un objeto nuevo cada vez aunque el
    // contenido no cambie, y connect() nunca podría saltarse un render. El
    // snapshot crudo sí mantiene su misma referencia entre dispatches que
    // no lo tocan. El .val() se hace más abajo, al pasarlo a AtleteControls.
    puntosControl: state.events.puntosControl,
  };
};

const AtleteReportsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AtleteReportsContainerView);

export default AtleteReportsContainer;
